import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import { Button } from '@openx/components-core/lib/Button/Button';
import { useTranslation } from 'react-i18next';
import { LEGAL_NOTICE_DRAWER_ID } from './DealTroubleshootingLegalNotice.constants';

type DealTroubleshootingLegalNoticeButtonProps = {
  open: boolean;
  onClick: () => void;
};

export const DealTroubleshootingLegalNoticeButton = ({ open, onClick }: DealTroubleshootingLegalNoticeButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button
      variant="text"
      color="secondary"
      size="small"
      aria-controls={LEGAL_NOTICE_DRAWER_ID}
      aria-expanded={open}
      startIcon={<ArticleOutlinedIcon sx={{ fontSize: 18 }} />}
      onClick={onClick}
      sx={{
        alignSelf: 'flex-start',
        flexWrap: 'nowrap',
        ml: 1,
        textWrap: 'nowrap',
        whiteSpace: 'nowrap',
        '& .MuiButton-startIcon': {
          mr: 0.5,
        },
      }}
    >
      {t('Legal Notice')}
    </Button>
  );
};
